import { useState, useEffect } from 'react';

export const ADMIN_GROUPS = ['fund_staff', 'admin']
const MESSAGE_SETTING_TIMEOUT = 120000 // 2 mins
export const MESSAGE_STATUSES = {
    deleted: 'deleted',
    edited: 'edited',
    sent: 'sent'
}

export default function useDiscussionMessage({user, message, owner, setContent, setEditingId}) {
    const [isHovered, setIsHovered] = useState(false);
    const [timeOut, setTimeOut] = useState(owner ? false : true);
    const programme_logo_path = document.body.getAttribute('data-small-logo-path') || '';
    const user_logo_path = user.profile_pic_url ? user.profile_pic_url : programme_logo_path;

    useEffect(() => {
        let intervalId;
        const created_at = message.created_at;
        if (!timeOut && created_at) {
            const expiryTime = new Date(created_at).getTime() + MESSAGE_SETTING_TIMEOUT;
            
            const checkTime = () => {
            if (Date.now() > expiryTime) {
                setTimeOut(true);
            }
            };
        
            checkTime();
            intervalId = setInterval(checkTime, 1000);
        }
        // Make sure the edit is under 2 min for sync fetching
        if (!intervalId && timeOut){
            setContent('');
            setEditingId(null);
        }
        
        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [message, timeOut]);

    return {
        isHovered,
        setIsHovered,
        user_logo_path,
        timeOut,
        programme_logo_path
    }
}